import { defaultHrmBreakTimeDto, HrmBreakTimeDto } from "src/dtos/hrmBreakTime/hrmBreakTimeDto";
import { defaultHrmWorkShiftDto, HrmWorkShiftDto } from "src/dtos/hrmWorkShift/hrmWorkShiftDto";

/** 저장 요청·응답의 모양이다. 근무조 1건과 그 근무조의 휴게 전체 목록을 함께 담는다. */
export interface HRM3050_R01Dto {
    hrmWorkShiftDto: HRM3050_R01HeaderDto; // 저장할 근무조 1건
    hrmBreakTimeDtoList: HRM3050_R01DetailDto[]; // 저장 후 남아야 할 휴게 전체 목록. 삭제 표시한 행은 뺀다.
}

/** 근무조 그리드 한 행이다. 1일 소정근로는 화면에서 계산하고 저장하지 않으므로 화면 전용 필드가 없다. */
export interface HRM3050_R01HeaderDto extends HrmWorkShiftDto {
}

/** 휴게시간 그리드 한 행이다. 시간(분)·처리 설명은 화면에서 계산하고 저장하지 않으므로 화면 전용 필드가 없다. */
export interface HRM3050_R01DetailDto extends HrmBreakTimeDto {
}

/** 근무조 신규 행과 서버 응답의 누락 필드를 채울 기본값이다. */
export const defaultHRM3050_R01HeaderDto: HRM3050_R01HeaderDto = {
    ...defaultHrmWorkShiftDto,
};

/** 휴게 신규 행과 서버 응답의 누락 필드를 채울 기본값이다. */
export const defaultHRM3050_R01DetailDto: HRM3050_R01DetailDto = {
    ...defaultHrmBreakTimeDto,
};

/** 빈 저장 DTO 기본값이다. */
export const defaultHRM3050_R01Dto: HRM3050_R01Dto = {
    hrmWorkShiftDto: { ...defaultHRM3050_R01HeaderDto },
    hrmBreakTimeDtoList: [],
};
